import useCreate from "./hooks/useCreate";
import UISchemaJson from "./schema/UISchema.json";
import { Sites } from "data/utils/globals";
import { SchemaData } from "./hooks/types";
import { CreateGql } from "./queries/create";
import { GenericMethods } from "layouts/aplicacoes/GenericMethods";
import useTemplate from "./hooks/useTemplate";

function Create() {
  const { templateSchema } = useTemplate(true);

  if (!templateSchema) return null;

  return (
    <GenericMethods.Create<SchemaData, CreateGql>
      siteId={Sites.UNIFTEC.id}
      sitePath={Sites.UNIFTEC.path}
      useCreate={useCreate}
      template={{
        schemaJson: templateSchema,
        UISchema: UISchemaJson,
      }}
    />
  );
}

export default Create;
